"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useGetConsultantNumber = void 0;
var _auth = require("@ori/auth");
var _checkoutUtils = require("@ori/checkout-utils");
var _globalApiClientReact = require("@ori/global-api-client-react");
const useGetConsultantNumber = (param)=>{
    let { customerId, tenant } = param;
    const { data: consultantNumber, error, isValidating: isConsultantNumberLoading } = (0, _globalApiClientReact.useGetCustomerConsultantNumber)(customerId, {
        [_checkoutUtils.TENANT_CONTEXT]: tenant
    }, {
        swr: {
            enabled: Boolean(customerId !== _auth.NOT_LOGGED_IN_USER_ID),
            ..._checkoutUtils.errorHandlingSwrOptions
        }
    });
    return {
        consultantNumber,
        error,
        isConsultantNumberLoading
    };
};
exports.useGetConsultantNumber = useGetConsultantNumber;
